import { Window } from './Window';

export class RectangularWindow extends Window {
  constructor(renderer, parent, def) {
    super(renderer, parent, def);
  }

  _create2DVertices(width, height, adjust, geometryData) {
    return create2DVertices(width, height, adjust);
  }
}

export function create2DVertices(width, height, adjust) {
  const hw = width / 2;
  const hh = height / 2;
  const a = adjust;

  const l = -hw - a.VSP; // Left
  const r = hw + a.HSP; // Right
  const t = hh + a.OVP; // Top
  const b = -hh - a.UNP; // Bottom

  return [
    l,
    t, // Top left
    r,
    t, // Top right
    r,
    b, // Bottom right
    l,
    b, // Bottom left
  ];
}
